import { STORAGE_KEYS } from '~constants'

export const ownerTokenStore = {
  subscribe: (listener: () => void) => {
    window.addEventListener('storage', listener)
    return () => window.removeEventListener('storage', listener)
  },
  getSnapshot: () => {
    return localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN) || ''
  },
}

export const guestTokenStore = {
  subscribe: (listener: () => void) => {
    window.addEventListener('storage', listener)
    return () => window.removeEventListener('storage', listener)
  },
  getSnapshot: () => {
    return localStorage.getItem(STORAGE_KEYS.GUEST_TOKEN) || ''
  },
}
